import { render, staticRenderFns } from "./dishCard.vue?vue&type=template&id=da45ef96&scoped=true&"
import script from "./dishCard.vue?vue&type=script&lang=js&"
export * from "./dishCard.vue?vue&type=script&lang=js&"
import style0 from "./dishCard.vue?vue&type=style&index=0&id=da45ef96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da45ef96",
  null
  
)

export default component.exports